"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadComponent = exports.OPEN_EXCEL_MIME_TYPE = exports.EXCEL_MIME_TYPE = exports.CSV_MIME_TYPE = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const core_shared_2 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const mithril_component_1 = require("../mithril.component");
const notification_service_1 = require("../notification.toast/notification.service");
const theme_1 = require("../theme");
const FileUploadCSS = {
    container: 'c-FileUpload',
    text: 'c-FileUpload__text',
    file: 'c-FileUpload__file',
    form: 'c-FileUpload__form',
    isDragging: 'c-FileUpload--is-dragging',
    isActive: 'c-FileUpload--is-active'
};
(0, theme_1.addStyles)({
    [FileUploadCSS.form]: {
        width: '100%',
        height: '100%'
    },
    [FileUploadCSS.container]: {
        width: '100%',
        height: '100%',
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center',
        border: '1px solid ' + theme_1.DefaultTheme.font.color.disabled,
        '&:hover': {
            border: '1px solid ' + theme_1.DefaultTheme.color.accent,
            cursor: 'pointer'
        }
    },
    [FileUploadCSS.isDragging]: {
        cursor: 'inherit',
        border: 'none',
        'font-size': '200%',
        color: theme_1.DefaultTheme.font.color.white,
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        width: '100%',
        height: '100%',
        'background-color': theme_1.DefaultTheme.font.color.supporting,
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center',
        'z-index': 99
    },
    [FileUploadCSS.file]: {
        display: 'none'
    }
});
exports.CSV_MIME_TYPE = 'text/csv';
exports.EXCEL_MIME_TYPE = 'application/vnd.ms-excel';
exports.OPEN_EXCEL_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
class FileUploadComponent extends mithril_component_1.IMithrilComponent {
    get isFilePresent() {
        return this.file != null;
    }
    constructor() {
        super();
        this.maxSize = 100 * 1024;
        this.allowedTypes = [exports.CSV_MIME_TYPE, exports.EXCEL_MIME_TYPE, exports.OPEN_EXCEL_MIME_TYPE];
        this.uploadType = 'text';
        this.isActive = false;
        this.isDraggingFile = false;
        this.file = null;
        // Slight delay to hide the drop area
        this.onBlurTask = new core_shared_2.IkeDelayedTask(this.onWindowDragLeaveClear, 25);
        this.fileId = 'file-' + core_shared_1.IkeId.generate();
    }
    get nodes() {
        let className = FileUploadCSS.container;
        if (this.isActive) {
            className += ' ' + FileUploadCSS.isActive;
        }
        if (this.isDraggingFile) {
            className += ' ' + FileUploadCSS.isDragging;
        }
        if (this.file) {
            return (0, mithril_1.m)('div', [
                this.file.name,
                (0, mithril_1.m)('pre', this.file.text)
            ]);
        }
        return (0, mithril_1.m)('form', { className: FileUploadCSS.form }, [
            (0, mithril_1.m)('input', { className: FileUploadCSS.file, type: 'file', id: this.fileId, onchange: this.onFile }, ''),
            (0, mithril_1.m)('div', {
                className,
                onclick: this.openFileDialog,
                ondragover: this.activate,
                ondragleave: this.deactivate,
                ondragend: this.deactivate,
                ondrop: this.update
            }, [this.isDraggingFile ? 'Drop file here' : 'Drag files here or click to upload'])
        ]);
    }
    onFile(e) {
        const fileInput = e.target;
        if (fileInput == null) {
            throw new Error('Unable to find file input: "' + this.fileId + '\'');
        }
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'file:click', 'button', 1);
        this.loadFiles(fileInput.files);
    }
    reset() {
        this.file = null;
    }
    activate(e) {
        e.preventDefault();
        this.isActive = true;
    }
    deactivate() {
        this.isActive = false;
    }
    update(e) {
        e.preventDefault();
        if (e.dataTransfer == null) {
            return;
        }
        this.deactivate();
        this.isDraggingFile = false;
        const files = e.dataTransfer.files;
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'file:drop', 'drop', 1);
        this.loadFiles(files);
    }
    loadFiles(files) {
        this.file = null;
        if (files == null) {
            return;
        }
        if (files.length > 1) {
            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'file:count', String(files.length), 1);
            notification_service_1.NotificationService.error({ key: i18n_1.T.FILE_NOT_SUPPORTED });
            return;
        }
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (this.maxSize < file.size) {
                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'file:large', 'large', file.size);
                notification_service_1.NotificationService.error({ key: i18n_1.T.FILE_TOO_LARGE });
                continue;
            }
            const fileType = file.type.toLowerCase();
            if (fileType !== '' && this.allowedTypes.indexOf(fileType) === -1) {
                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'file:type', fileType, 1);
                notification_service_1.NotificationService.error({ key: i18n_1.T.FILE_NOT_SUPPORTED });
                continue;
            }
            this.file = new FileUploadTextReader(file, this.uploadType);
        }
    }
    openFileDialog(e) {
        e.preventDefault();
        const fileInput = document.getElementById(this.fileId);
        if (fileInput == null) {
            throw new Error('Unable to find file input: "' + this.fileId + '\'');
        }
        var evt = document.createEvent('MouseEvents');
        evt.initEvent('click', true, false);
        fileInput.dispatchEvent(evt);
    }
    onWindowDragOver(e) {
        this.onBlurTask.cancel();
        if (e.dataTransfer && e.dataTransfer.types && e.dataTransfer.types.indexOf('Files') > -1) {
            this.isDraggingFile = true;
        }
    }
    onWindowDragLeave(e) {
        if (this.onBlurTask.isActive) {
            return;
        }
        this.onBlurTask.delay();
    }
    onWindowDragLeaveClear() {
        this.isDraggingFile = false;
    }
    onCreate() {
        services_1.Services.Window.document.addEventListener('blur', this.onWindowDragLeave);
        services_1.Services.Window.document.addEventListener('dragleave', this.onWindowDragLeave);
        services_1.Services.Window.document.addEventListener('dragover', this.onWindowDragOver);
    }
    onRemove() {
        services_1.Services.Window.document.removeEventListener('blur', this.onWindowDragLeave);
        services_1.Services.Window.document.removeEventListener('dragleave', this.onWindowDragLeave);
        services_1.Services.Window.document.removeEventListener('dragover', this.onWindowDragOver);
    }
}
exports.FileUploadComponent = FileUploadComponent;
tslib_1.__decorate([
    mobx_1.observable
], FileUploadComponent.prototype, "isActive", void 0);
tslib_1.__decorate([
    mobx_1.observable
], FileUploadComponent.prototype, "isDraggingFile", void 0);
tslib_1.__decorate([
    mobx_1.observable.shallow
], FileUploadComponent.prototype, "file", void 0);
tslib_1.__decorate([
    mobx_1.computed
], FileUploadComponent.prototype, "isFilePresent", null);
tslib_1.__decorate([
    mobx_1.action.bound
], FileUploadComponent.prototype, "onFile", null);
tslib_1.__decorate([
    mobx_1.action.bound
], FileUploadComponent.prototype, "reset", null);
tslib_1.__decorate([
    mobx_1.action.bound
], FileUploadComponent.prototype, "activate", null);
tslib_1.__decorate([
    mobx_1.action.bound
], FileUploadComponent.prototype, "deactivate", null);
tslib_1.__decorate([
    mobx_1.action.bound
], FileUploadComponent.prototype, "update", null);
tslib_1.__decorate([
    mobx_1.action.bound
], FileUploadComponent.prototype, "openFileDialog", null);
tslib_1.__decorate([
    mobx_1.action.bound
], FileUploadComponent.prototype, "onWindowDragOver", null);
tslib_1.__decorate([
    mobx_1.action.bound
], FileUploadComponent.prototype, "onWindowDragLeave", null);
tslib_1.__decorate([
    mobx_1.action.bound
], FileUploadComponent.prototype, "onWindowDragLeaveClear", null);
class FileUploadTextReader {
    constructor(file, type) {
        this.text = null;
        this.isFailed = false;
        this.isLoading = true;
        this.name = file.name;
        this.type = file.type;
        this.size = file.size;
        this.fileReader = new FileReader();
        this.fileReader.onerror = this.onFileError;
        this.fileReader.onload = this.onFileLoad;
        if (type === 'text') {
            this.fileReader.readAsText(file);
        }
        else {
            this.fileReader.readAsArrayBuffer(file);
        }
    }
    onFileError() {
        this.fileReader.abort();
        this.isFailed = true;
        this.isLoading = false;
    }
    onFileLoad() {
        this.isFailed = false;
        this.isLoading = false;
        this.text = this.fileReader.result;
        this.fileReader = null;
    }
}
tslib_1.__decorate([
    mobx_1.observable
], FileUploadTextReader.prototype, "text", void 0);
tslib_1.__decorate([
    mobx_1.observable
], FileUploadTextReader.prototype, "isFailed", void 0);
tslib_1.__decorate([
    mobx_1.observable
], FileUploadTextReader.prototype, "isLoading", void 0);
tslib_1.__decorate([
    mobx_1.action.bound
], FileUploadTextReader.prototype, "onFileError", null);
tslib_1.__decorate([
    mobx_1.action.bound
], FileUploadTextReader.prototype, "onFileLoad", null);
//# sourceMappingURL=file.upload.js.map